import type { Novidade } from './tipos';

/** Fase 2 (W34): aplicar a nota de crédito numa ou mais faturas do mesmo cliente, sem dinheiro em caixa, e desfazer. */
export const novidadeNotaCredito: Novidade = {
  id: '2026-10-05-nota-credito',
  publicada_em: '2026-10-05',
  tipo: 'novo',
  modulo: 'contas',
  permissao: 'contas.baixar',
  textos: {
    pt: {
      titulo: 'Aplicar nota de crédito em fatura',
      resumo: 'Use o crédito do cliente para abater faturas em aberto dele, sem dinheiro em caixa: o saldo da nota e o da fatura caem no mesmo valor.',
      passos: [
        'Em Financeiro > Notas de crédito, clique em "Aplicar em fatura" na linha da nota (ou abra a nota e use o botão do rodapé).',
        'Aparecem as faturas em aberto do mesmo cliente e da mesma empresa, com o crédito já repartido pela que vence primeiro; ajuste o valor de cada uma.',
        'Confirme em "Aplicar crédito": a fatura que zera fica paga e a aplicação aparece nas duas fichas, sem lançamento no Financeiro.',
        'Errou? Na ficha da nota ou da fatura, use "Desfazer" na aplicação e informe o motivo: os saldos voltam e nada é apagado.',
      ],
    },
    en: {
      titulo: 'Apply a credit note to an invoice',
      resumo: "Use the customer's credit to offset their open invoices, with no cash: the credit note and invoice balances drop by the same amount.",
      passos: [
        'In Finance > Credit notes, click "Apply to invoice" on the credit note row (or open the credit note and use the footer button).',
        'The open invoices of the same customer and company show up, with the credit already spread from the one due first; adjust the amount for each one.',
        'Confirm with "Apply credit": the invoice that reaches zero becomes paid and the application shows on both records, with no entry in Finance.',
        'Made a mistake? On the credit note or the invoice, use "Undo" on the application and enter the reason: the balances come back and nothing is deleted.',
      ],
    },
    es: {
      titulo: 'Aplicar nota de crédito en factura',
      resumo: 'Usa el crédito del cliente para descontar sus facturas abiertas, sin caja: el saldo de la nota y el de la factura bajan lo mismo.',
      passos: [
        'En Finanzas > Notas de crédito, haz clic en "Aplicar en factura" en la fila de la nota (o abre la nota y usa el botón del pie).',
        'Aparecen las facturas abiertas del mismo cliente y de la misma empresa, con el crédito ya repartido desde la que vence primero; ajusta el valor de cada una.',
        'Confirma en "Aplicar crédito": la factura que llega a cero queda pagada y la aplicación aparece en las dos fichas, sin asiento en Finanzas.',
        '¿Te equivocaste? En la ficha de la nota o de la factura, usa "Deshacer" en la aplicación e indica el motivo: los saldos vuelven y no se borra nada.',
      ],
    },
  },
  imagens: ['/novidades/2026-10-05-nota-credito/lista.webp', '/novidades/2026-10-05-nota-credito/aplicar.webp', '/novidades/2026-10-05-nota-credito/ficha.webp', null],
  treinamento: { curso: 'novidades' },
  rota: '/financeiro/contas/notas-credito',
};
